import { render, staticRenderFns } from "./VendorGstForm.vue?vue&type=template&id=25181220&"
import script from "./VendorGstForm.vue?vue&type=script&lang=js&"
export * from "./VendorGstForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports